import { put, takeLatest } from "redux-saga/effects";
import { requestMomList } from "services/mom";
import { fetchMomFailure, fetchMomListRequest, fetchMomListSuccess } from "redux/reducers/mom";

export function* watchMomSaga() {

    // yield takeLatest(fetchMomListRequest, fetchMomList);
}

function* fetchMomList({ payload }) {
    try {
        const response = yield requestMomList(payload);
        yield put(fetchMomListSuccess(response));
    } catch (error) {
        yield put(fetchMomFailure("Failed to get list of Mom"));
    }
}
